module.exports = __webpack_public_path__ + "img/v2_328.4cb27573.png";